class ProductForm extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.modalId = this.dataset.modalId;
    this.miniCart = document.getElementById('mini-cart');
    this.bisButton = this.form.querySelector('.js-show-form-bis');
    this.errorMessageWrapper = this.querySelector('.js-error-wrapper') || false;
    this.errorMessageEl = this.errorMessageWrapper && this.errorMessageWrapper.querySelector('.js-error-message') || false;

    this.bisButton?.addEventListener('click', (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('open-modal', {
        detail: {
          modal_name: `js-bis-form-${this.modalId}`
        }
      }))
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  onSubmitHandler(evt) {
    evt.preventDefault()

    const submitButton = this.querySelector('[type="submit"]')
    const statusBlock = document.querySelector('product-totals')

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading')

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    formData.append('sections', this.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    const product_title = formData.get('product_title')

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.text())
      .then(async (state) => {
        const parsedState = JSON.parse(state)

        if (parsedState.status) {
          this.handleErrorMessage(parsedState.description);
          return;
        }

        this.handleErrorMessage();

        const cartItems = window.__CART__.items
        let alreadyInCart = false
        if (cartItems.length) {
          window.__CART__.items.map((item) => {
            if (item.id === parsedState.id) {
              item.quantity = parsedState.quantity
              alreadyInCart = true
            }
          })
        }
        if (!alreadyInCart) {
          window.__CART__.items.push(parsedState)
        }

        window.__CART__.sections = parsedState.sections
        window.__CART__.total_price = window.__CART__.total_price + parsedState.line_price

        const updatedCart = await window.__CART__CONTROLLER__.updateCartFreeGift(window.__CART__)

        window.__CART__ = { ...updatedCart }

        const newCartCount = updatedCart.items.reduce((prev, curr) => prev + curr.quantity, 0);
        document.querySelectorAll(".js-product-totals").forEach(el => {
          if (newCartCount > 9) {
            el.innerText = '9+';
          } else {
            el.innerText = newCartCount;
          }
        });

        this.getSectionsToRender().forEach((section) => {
          if (document.getElementById(section.id) === null) return

          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            updatedCart.sections[section.section],
            section.selector
          )
        })

        const cartNotification = document.querySelector('cart-notification')

        if (!cartNotification || isDesktop()) {
          document.getElementById('cart-icon-bubble').click()
        } else {
          cartNotification.renderContents(parsedState, product_title)
        }

      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        submitButton.classList.remove('loading')
        submitButton.removeAttribute('aria-disabled')
        statusBlock?.updateText(JSON.parse(body)?.quantity)
        document.querySelector(".js-product-recommendations")?.classList.remove("loading");
      })
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper && this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      if (typeof errorMessage !== 'object') {
        this.errorMessageEl.textContent = errorMessage;
      } else {
        for(const key in errorMessage) {
          if(errorMessage.hasOwnProperty(key)) {
            const value = errorMessage[key];
            this.errorMessageEl.textContent = value;
          }
        }
      }
    }
  }
}

customElements.define('product-form', ProductForm)
